import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommentsInterna } from '../entities/commentsinterna.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CommentsInternaService {
    readonly BASE: any = PETICIONES.commentsinterna;

    constructor(private http: HttpClient) { }

    /**
    * @description
    * Obtiene todos los commentsinterna
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene un commentsinterna por su id
    */
    public findById(id: number): Observable<any> {
        let idCom: string = (id !== undefined && id !== null ? id + "" : "");
        return this.http.get(this.BASE.findById + "/" + idCom).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene una lista de commentsinterna por su dboid
    */
    public findByDboid(dboid: string): Observable<any> {
        let userdboid: string = (dboid !== undefined && dboid !== null ? dboid + "" : "");
        return this.http.get(this.BASE.findByDboid + "/" + userdboid).pipe(delay(DELAY));
    }


    /**
    * @description
    * Guarda un commentsinterna en la base de datos
    */
    public postCommentsInterna(commets: CommentsInterna): Observable<any> {
        const json = JSON.stringify(commets);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postCommentsInterna, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Borra un commentsinterna en la base de datos
    */
    public deleteCommentsInterna(comments: CommentsInterna): Observable<any> {
        let idComments: string = (comments.id !== undefined && comments.id !== null ? comments.id + "" : "");
        return this.http.get(this.BASE.deleteCommentsInterna + "/" + idComments).pipe(delay(DELAY));
    }
}